export interface Site {
  id: number;
  name: string;
  url: string;
  description: string;
  category: string;
  icon: string;
  tags: string[];
  isFeatured: boolean;
}

export const sites: Site[] = [
  // 工具推荐
  {
    id: 1,
    name: "DeepL 翻译",
    url: "https://www.deepl.com",
    description: "全球最精准的机器翻译工具，支持31种语言互译，翻译质量远超同类产品",
    category: "gongju-tuijian",
    icon: "ri-translate-2",
    tags: ["翻译", "语言", "AI"],
    isFeatured: true,
  },
  {
    id: 2,
    name: "Canva 可画",
    url: "https://www.canva.cn",
    description: "在线平面设计工具，海量模板助你轻松制作海报、PPT、社交媒体图片",
    category: "gongju-tuijian",
    icon: "ri-brush-line",
    tags: ["设计", "平面", "模板"],
    isFeatured: true,
  },
  {
    id: 3,
    name: "石墨文档",
    url: "https://shimo.im",
    description: "国内领先的在线协作文档工具，支持多人实时编辑与云端同步",
    category: "gongju-tuijian",
    icon: "ri-file-text-line",
    tags: ["文档", "协作"],
    isFeatured: false,
  },
  {
    id: 4,
    name: "ProcessOn",
    url: "https://www.processon.com",
    description: "免费在线流程图、思维导图制作工具，支持团队协作编辑",
    category: "gongju-tuijian",
    icon: "ri-mind-map",
    tags: ["流程图", "思维导图"],
    isFeatured: false,
  },
  // 资源下载
  {
    id: 5,
    name: "站酷素材",
    url: "https://www.zcool.com.cn",
    description: "国内最大的设计师互动平台，提供海量设计素材、字体、模板下载",
    category: "ziyuan-xiazai",
    icon: "ri-image-line",
    tags: ["设计", "素材", "字体"],
    isFeatured: true,
  },
  {
    id: 6,
    name: "Unsplash",
    url: "https://unsplash.com",
    description: "免费高品质图片素材网站，摄影师社区，所有图片可免费商用",
    category: "ziyuan-xiazai",
    icon: "ri-camera-line",
    tags: ["图片", "摄影", "免费"],
    isFeatured: true,
  },
  {
    id: 7,
    name: "IconPark",
    url: "https://iconpark.oceanengine.com",
    description: "字节跳动开源的图标库，提供2000+高质量图标，支持在线编辑",
    category: "ziyuan-xiazai",
    icon: "ri-shapes-line",
    tags: ["图标", "开源"],
    isFeatured: false,
  },
  // 设计灵感
  {
    id: 8,
    name: "Dribbble",
    url: "https://dribbble.com",
    description: "全球设计师社区，探索数百万设计师的创意作品与设计趋势",
    category: "sheji-linggan",
    icon: "ri-dribbble-line",
    tags: ["设计", "社区", "作品集"],
    isFeatured: true,
  },
  {
    id: 9,
    name: "Behance",
    url: "https://www.behance.net",
    description: "Adobe 旗下全球创意作品展示平台，涵盖设计、插画、摄影等领域",
    category: "sheji-linggan",
    icon: "ri-behance-line",
    tags: ["创意", "作品", "Adobe"],
    isFeatured: false,
  },
  {
    id: 10,
    name: "Awwwards",
    url: "https://www.awwwards.com",
    description: "全球网页设计大奖评选平台，收录最优秀的网站设计作品",
    category: "sheji-linggan",
    icon: "ri-award-line",
    tags: ["网页", "设计", "奖项"],
    isFeatured: false,
  },
  // 学习平台
  {
    id: 11,
    name: "中国大学MOOC",
    url: "https://www.icourse163.org",
    description: "汇聚国内顶尖高校优质课程，免费在线学习平台",
    category: "xuexi-pingtai",
    icon: "ri-graduation-cap-line",
    tags: ["课程", "大学", "免费"],
    isFeatured: true,
  },
  {
    id: 12,
    name: "掘金",
    url: "https://juejin.cn",
    description: "面向开发者的技术分享社区，涵盖前端、后端、AI等热门技术方向",
    category: "xuexi-pingtai",
    icon: "ri-code-line",
    tags: ["技术", "社区", "开发"],
    isFeatured: true,
  },
  {
    id: 13,
    name: "Bilibili 知识区",
    url: "https://www.bilibili.com/v/knowledge",
    description: "B站知识区汇集海量优质视频教程，覆盖编程、设计、人文等各类知识",
    category: "xuexi-pingtai",
    icon: "ri-bilibili-line",
    tags: ["视频", "教程", "知识"],
    isFeatured: false,
  },
  // 新闻资讯
  {
    id: 14,
    name: "少数派",
    url: "https://sspai.com",
    description: "数字生活指南，聚焦效率工具、数码产品评测与生活方式分享",
    category: "xinwen-zixun",
    icon: "ri-article-line",
    tags: ["科技", "效率", "数码"],
    isFeatured: true,
  },
  {
    id: 15,
    name: "36氪",
    url: "https://36kr.com",
    description: "深度商业科技媒体，第一时间报道创业、科技、投资新闻",
    category: "xinwen-zixun",
    icon: "ri-rocket-line",
    tags: ["科技", "创业", "商业"],
    isFeatured: false,
  },
  // 生活娱乐
  {
    id: 16,
    name: "豆瓣",
    url: "https://www.douban.com",
    description: "中国领先的文化生活社区，涵盖书影音评论、小组讨论和同城活动",
    category: "shenghuo-yule",
    icon: "ri-chat-1-line",
    tags: ["社区", "影评", "书评"],
    isFeatured: true,
  },
  {
    id: 17,
    name: "网易云音乐",
    url: "https://music.163.com",
    description: "国内最受欢迎的音乐平台之一，拥有海量曲库和精准推荐算法",
    category: "shenghuo-yule",
    icon: "ri-music-line",
    tags: ["音乐", "推荐", "社区"],
    isFeatured: false,
  },
  // 开发编程
  {
    id: 18,
    name: "GitHub",
    url: "https://github.com",
    description: "全球最大的代码托管平台，开源社区，开发者协作的必备工具",
    category: "kaifa-biancheng",
    icon: "ri-github-line",
    tags: ["开源", "代码", "协作"],
    isFeatured: true,
  },
  {
    id: 19,
    name: "Stack Overflow",
    url: "https://stackoverflow.com",
    description: "全球最大的程序员问答社区，解决编程难题的首选平台",
    category: "kaifa-biancheng",
    icon: "ri-stack-overflow-line",
    tags: ["问答", "编程", "社区"],
    isFeatured: false,
  },
  {
    id: 20,
    name: "MDN Web Docs",
    url: "https://developer.mozilla.org",
    description: "Mozilla 维护的 Web 开发技术文档，前端开发者必备参考手册",
    category: "kaifa-biancheng",
    icon: "ri-file-code-line",
    tags: ["文档", "前端", "Web"],
    isFeatured: false,
  },
  // 办公协同
  {
    id: 21,
    name: "飞书",
    url: "https://www.feishu.cn",
    description: "字节跳动旗下企业协作平台，整合即时通讯、文档、日历、视频会议",
    category: "bangong-xietong",
    icon: "ri-send-plane-line",
    tags: ["协作", "办公", "通讯"],
    isFeatured: true,
  },
  {
    id: 22,
    name: "Notion",
    url: "https://www.notion.so",
    description: "全能型笔记与知识管理工具，集文档、数据库、项目管理于一体",
    category: "bangong-xietong",
    icon: "ri-sticky-note-line",
    tags: ["笔记", "知识管理", "团队"],
    isFeatured: false,
  },
];

export const getSitesByCategory = (categorySlug: string): Site[] => {
  return sites.filter((s) => s.category === categorySlug);
};

export const getFeaturedSites = (): Site[] => {
  return sites.filter((s) => s.isFeatured);
};

export const getSiteById = (id: number): Site | null => {
  return sites.find((s) => s.id === id) || null;
};

export const searchSites = (keyword: string): Site[] => {
  const kw = keyword.toLowerCase();
  return sites.filter(
    (s) =>
      s.name.toLowerCase().includes(kw) ||
      s.description.toLowerCase().includes(kw) ||
      s.tags.some((t) => t.toLowerCase().includes(kw))
  );
};